import * as api from '@gitbook/api-client';
import { Description, FieldGroup, Label, type TileOption, TilePicker } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';
import sidebarListDefaultDarkImage from './assets/sidebar-list-default-dark.svg';
import sidebarListDefaultLightImage from './assets/sidebar-list-default-light.svg';
import sidebarListLineDarkImage from './assets/sidebar-list-line-dark.svg';
import sidebarListLineLightImage from './assets/sidebar-list-line-light.svg';
import sidebarListPillDarkImage from './assets/sidebar-list-pill-dark.svg';
import sidebarListPillLightImage from './assets/sidebar-list-pill-light.svg';

/**
 * Settings to configure the style for the sidebar list and selected items
 */
export function SidebarListStyleSetting(props: SitesCustomizationPanelProps) {
    const { settings, setSettings } = props;

    return (
        <>
            <FieldGroup>
                <Label>List style</Label>
                <Description>Choose sidebar list and selected items style</Description>
            </FieldGroup>
            <TilePicker
                aria-label="List style"
                items={LIST_STYLE_OPTIONS}
                selectedItem={settings.styling.sidebar.list}
                setSelectedItem={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            sidebar: {
                                ...prev.styling?.sidebar,
                                list: value,
                            },
                        },
                    }));
                }}
            />
        </>
    );
}

const LIST_STYLE_OPTIONS: TileOption<api.CustomizationSidebarListStyle>[] = [
    {
        value: api.CustomizationSidebarListStyle.Default,
        label: 'Default',
        asset: {
            light: sidebarListDefaultLightImage,
            dark: sidebarListDefaultDarkImage,
        },
    },
    {
        value: api.CustomizationSidebarListStyle.Pill,
        label: 'Pill',
        asset: {
            light: sidebarListPillLightImage,
            dark: sidebarListPillDarkImage,
        },
    },
    {
        value: api.CustomizationSidebarListStyle.Line,
        label: 'Line',
        asset: {
            light: sidebarListLineLightImage,
            dark: sidebarListLineDarkImage,
        },
    },
];
